// extracted by mini-css-extract-plugin
module.exports = {"subtitle":"Experiences_subtitle__3FIia","title":"Experiences_title__IlVLS","button":"Experiences_button__1WnNe","experiencesSwiper":"Experiences_experiencesSwiper__3lzCo"};